import { render, staticRenderFns } from "./SetReferalRules.vue?vue&type=template&id=6b6cf677&scoped=true"
import script from "./SetReferalRules.vue?vue&type=script&lang=js"
export * from "./SetReferalRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6cf677",
  null
  
)

export default component.exports